"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Footer_1 = require("../components/Footer/Footer");
var targetNode = document.querySelector('.footer-container');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Footer_1.default, null), targetNode);
}
